export default function filterOutUndefined(array) {
  return array.filter(x => x !== undefined);
}